module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/loadingView.html -->\n<div class="flex-column-grid flex-align-center" data-nx-loading="true">\n  <div\n    id="loading-view-loader"\n    class="loader nx-autotemplate"\n    data-nx-template="loader"\n  ></div>\n  <p></p>\n  <p>'+
((__t=( message ))==null?'':__t)+
'</p>\n</div>\n';
}
return __p;
};
